import { PaginatedData } from '../../../../../models/List';
import { SearchTransactionLogSchema } from '../../../../../models/SearchParamSchema';
import { axiosFactory } from '../../../../client';
import { AuditDownloadResponse, TransactionLogSearchResponse } from '../models';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

export const getAuditAccountTypeList = () =>
  candidateClient.get<string[]>(`${ROUTES.GET_AUDIT_ACCOUNT_TYPE_LIST}`);

export const getAuditRoleList = () => candidateClient.get<string[]>(ROUTES.GET_AUDIT_ROLE_LIST);

export const getAuditActionList = () => candidateClient.get<string[]>(ROUTES.GET_AUDIT_ACTION_LIST);

export const postTransactionLog = (csrfToken: string, data: SearchTransactionLogSchema) =>
  candidateClient.post<PaginatedData<TransactionLogSearchResponse>>(
    csrfToken,
    ROUTES.POST_USER_API_AUDIT(data.page, data.size, data.startDate, data.endDate),
    {
      accountType: data.accountType,
      roles: data.roles,
      action: data.action,
      actionDateTime: data.actionDateTime,
    }
  );

/** to post download data
 * */
export const postAuditUploadData = (csrfToken: string, data: SearchTransactionLogSchema) =>
  candidateClient.post<AuditDownloadResponse>(
    csrfToken,
    `${ROUTES.POST_AUDIT_DOWNLOAD(data.startDate, data.endDate)}`,
    {
      accountType: data.accountType,
      roles: data.roles,
      action: data.action,
    }
  );
